import * as React from 'react';
import { CLASSNAME_PREFIX, IRELAND_VERIFICATION_FLOW } from './componentConfig';
import './VerificationJourney.scss';
import { Scenarios } from '@account-verification-frontend/scenarios-container';
import { Header } from '@account-verification-frontend/header';
import { IrelandVerificationJourney } from '@account-verification-frontend/ireland-verification-journey';
function VerificationJourney() {
    var flowValue = new URLSearchParams(window.location.search).get('flow');
    var isIEVerificationEnabled = flowValue === IRELAND_VERIFICATION_FLOW;
    if (isIEVerificationEnabled) {
        return (React.createElement("div", { className: "".concat(CLASSNAME_PREFIX, "-component ").concat(CLASSNAME_PREFIX, "-component--fullscreen") },
            React.createElement(IrelandVerificationJourney, null)));
    }
    return (React.createElement("div", { className: "".concat(CLASSNAME_PREFIX, "-component") },
        React.createElement(Header, null),
        React.createElement(Scenarios, null)));
}
export default VerificationJourney;
//# sourceMappingURL=VerificationJourney.js.map